import { AxiosError } from 'axios';
import { PUT_CANDIDATE_HISTORIES_ATTACH_FILE_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { PresignedUrlResponse } from '../../models/PresignedUrl';
import {GenericErrorResponse} from "../typings";
// =============================================================================
// Request & Response Model
// =============================================================================
export interface AttachedFile {
  fileName: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: PresignedUrlResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutAttachCandidateHistoriesFile = ({ onSuccess, onError }: Input) => {
  const putAttachCandidateHistoriesFile = async (payload: AttachedFile) => {
    const res = await axiosClient.put<PresignedUrlResponse>(
      PUT_CANDIDATE_HISTORIES_ATTACH_FILE_URL,
      {
        fileName: payload.fileName,
      }
    );
    return res.data;
  };

  return useCustomMutation(putAttachCandidateHistoriesFile, {
    onSuccess,
    onError,
  });
};
